import _ from "lodash"
import { Query } from "../query"
import { Store } from "../store"
import { EventEmitter } from "../event-emitter"
import { Entity } from "../entity"
import { SchemaIds } from "../schema"

export class PermissionsImpl extends EventEmitter {
  public static PERMISSIONS_CHANGED = 'RECORD_PENDING'

  apis: any
  store: any

  registrations: any[]

  public async initialize(apis) {
    this.apis = apis
    this.store = apis.getStore()

    this.store.addListener(Store.RECORD_CREATED, this.maybeRefreshListener)
    this.store.addListener(Store.RECORD_CHANGED, this.maybeRefreshListener)
    this.store.addListener(Store.RECORD_DELETED, this.maybeRefreshListener)

    this.loadData()
  }

  private maybeRefreshListener = (record: Entity) => {
    if (!record.hasMixin(SchemaIds.SCHEDULER_ACCESS_REGISTRATION)) {
      return
    }

    this.loadData()
  }

  private async loadData() {
    this.registrations = await this.apis.getPermissions()
    this.emit(PermissionsImpl.PERMISSIONS_CHANGED)
  }

  public getAll() {
    return this.registrations
  }
}

const permissions = new PermissionsImpl()
export default permissions
